

































































































































































































































































































































































































import { Component, Prop, Watch } from "vue-property-decorator";
import GiganautVueDialog from "@/components/Shared/GiganautVueDialog";
import TimesheetDto from "@/models/Timesheets/TimesheetDto";
import { BookingDetailsModule } from "@/store/modules/bookingDetails";
import ListUtils from "@/lib/listUtils";
import TimesheetViewModel from '@/models/Timesheets/TimesheetViewModel'
import DateTimeUtils from "@/lib/dateTimeUtils";
import JourneyType from "@/models/Timesheets/JourneyType";
import JourneyTemplateDto from "@/models/JourneyTemplates/JourneyTemplateDto";
import JourneyCalculationType from "@/models/Timesheets/JourneyCalculationType";
import WorkerMinimumPayRateRequest from "@/models/Workers/WorkerMinimumPayRateRequest";

@Component({
  name: "TimesheetEdit",
})
export default class extends GiganautVueDialog {
  
  public journeyType = JourneyType;
  journeyCalculationType = JourneyCalculationType

  @Prop({required: true})
  timesheetId: string;
  vm: TimesheetViewModel = new TimesheetViewModel();

  @Watch('vm.payRate')
  async onPayRateChanged(val: Date, oldVal: Date) {
    await this.calculateShift(); 
    await this.calculateTravel();  
  } 
  
  @Watch('vm.chargeRate')
  async onChargeRateChanged(val: Date, oldVal: Date) {
    await this.calculateShift();  
    await this.calculateTravel();  
  } 

  @Watch('vm.startAtTime')
  async onStartAtChanged(val: Date, oldVal: Date) {
    await this.calculateShift();  
  }

  @Watch('vm.endAtTime')
  async onEndAtChanged(val: Date, oldVal: Date) {
    await this.calculateShift();  
  }

  @Watch('vm.break')
  async onBreakChanged(val: number, oldVal: number) {
    await this.calculateShift();  
  }

  @Watch('vm.isPaidBreak')
  async onIsPaidBreakChanged(val: boolean, oldVal: boolean) {
    await this.calculateShift();  
  }

  @Watch('vm.journeyTemplateForPay')
  async onJourneyTemplateForPayChanged(val: JourneyTemplateDto, oldVal: JourneyTemplateDto) {
    if (val) {
      this.vm.journeyTemplateForPayId = val.id;
      this.vm.travelTimeOneWayTemplateForPay = val.travelTimeOneWay;
      this.vm.distanceOneWayTemplateForPay = val.distanceOneWay;
    } else {
      this.vm.journeyTemplateForPayId = null;
      this.vm.travelTimeOneWayTemplateForPay = 0;
      this.vm.totalTravelTimeForPay = 0;
      this.vm.distanceOneWayTemplateForPay = 0;
      this.vm.totalDistanceForPay = 0
    }
    await this.calculateTravel();
    //await this.calculateTravel(this.vm.journeyCalculationTypeForPay, this.vm.journeyCalculationTypeForCharge, this.vm.journeyType, this.vm.distanceOneWayManualForPay, this.vm.distanceOneWayManualForCharge, this.vm.distanceOneWayTemplateForPay, this.vm.distanceOneWayTemplateForCharge, this.vm.travelTimeOneWayManualForPay, this.vm.travelTimeOneWayManualForCharge, this.vm.travelTimeOneWayTemplateForPay, this.vm.travelTimeOneWayTemplateForCharge);
  }

   @Watch('vm.journeyTemplateForCharge')
  async onJourneyTemplateForChargeChanged(val: JourneyTemplateDto, oldVal: JourneyTemplateDto) {
    if (val) {
      this.vm.journeyTemplateForChargeId = val.id;
      this.vm.travelTimeOneWayTemplateForCharge = val.travelTimeOneWay;
      this.vm.distanceOneWayTemplateForCharge = val.distanceOneWay;
    } else {
      this.vm.journeyTemplateForChargeId = null;
      this.vm.travelTimeOneWayTemplateForCharge = 0;
      this.vm.totalTravelTimeForCharge = 0;
      this.vm.distanceOneWayTemplateForCharge = 0;
      this.vm.totalDistanceForCharge = 0
    }
    await this.calculateTravel();
    //await this.calculateTravel(this.vm.journeyCalculationTypeForPay, this.vm.journeyCalculationTypeForCharge, this.vm.journeyType, this.vm.distanceOneWayManualForPay, this.vm.distanceOneWayManualForCharge, this.vm.distanceOneWayTemplateForPay, this.vm.distanceOneWayTemplateForCharge, this.vm.travelTimeOneWayManualForPay, this.vm.travelTimeOneWayManualForCharge, this.vm.travelTimeOneWayTemplateForPay, this.vm.travelTimeOneWayTemplateForCharge);
  }

  @Watch('vm.journeyType')
  async onJourneyTypeChanged(val: JourneyType, oldVal: JourneyType) {
    await this.calculateTravel();
    //await this.calculateTravel(this.vm.journeyCalculationTypeForPay, this.vm.journeyCalculationTypeForCharge, val, this.vm.distanceOneWayManualForPay, this.vm.distanceOneWayManualForCharge, this.vm.distanceOneWayTemplateForPay, this.vm.distanceOneWayTemplateForCharge, this.vm.travelTimeOneWayManualForPay, this.vm.travelTimeOneWayManualForCharge, this.vm.travelTimeOneWayTemplateForPay, this.vm.travelTimeOneWayTemplateForCharge);
  }

  @Watch('vm.distanceOneWayManualForPay')
  async onDistanceOneWayManualForPayChanged(val: number, oldVal: number) {
    this.vm.distanceOneWayManualForPay = Number(val);
    await this.calculateTravel();
    //await this.calculateTravel(this.vm.journeyCalculationTypeForPay, this.vm.journeyCalculationTypeForCharge, this.vm.journeyType, val, this.vm.distanceOneWayManualForCharge, this.vm.distanceOneWayTemplateForPay, this.vm.distanceOneWayTemplateForCharge, this.vm.travelTimeOneWayManualForPay, this.vm.travelTimeOneWayManualForCharge, this.vm.travelTimeOneWayTemplateForPay, this.vm.travelTimeOneWayTemplateForCharge);
  }

  @Watch('vm.distanceOneWayManualForCharge')
  async onDistanceOneWayManualForChargeChanged(val: number, oldVal: number) {
    this.vm.distanceOneWayManualForCharge = Number(val);
    await this.calculateTravel();
    //await this.calculateTravel(this.vm.journeyCalculationTypeForPay, this.vm.journeyCalculationTypeForCharge, this.vm.journeyType, this.vm.distanceOneWayManualForPay, val, this.vm.distanceOneWayTemplateForPay, this.vm.distanceOneWayTemplateForCharge, this.vm.travelTimeOneWayManualForPay, this.vm.travelTimeOneWayManualForCharge, this.vm.travelTimeOneWayTemplateForPay, this.vm.travelTimeOneWayTemplateForCharge);
  }


  @Watch('vm.travelTimeOneWayManualForPay')
  async onTravelTimeOneWayManualForPayChanged(val: number, oldVal: number) {
    await this.calculateTravel();
    //await this.calculateTravel(this.vm.journeyCalculationTypeForPay, this.vm.journeyCalculationTypeForCharge, this.vm.journeyType, this.vm.distanceOneWayManualForPay, this.vm.distanceOneWayManualForCharge, this.vm.distanceOneWayTemplateForPay, this.vm.distanceOneWayTemplateForCharge, val, this.vm.travelTimeOneWayManualForCharge, this.vm.travelTimeOneWayTemplateForPay, this.vm.travelTimeOneWayTemplateForCharge);
  }

  @Watch('vm.travelTimeOneWayManualForCharge')
  async onTravelTimeOneWayManualForChargeChanged(val: number, oldVal: number) {
    await this.calculateTravel();
    //await this.calculateTravel(this.vm.journeyCalculationTypeForPay, this.vm.journeyCalculationTypeForCharge, this.vm.journeyType, this.vm.distanceOneWayManualForPay, this.vm.distanceOneWayManualForCharge, this.vm.distanceOneWayTemplateForPay, this.vm.distanceOneWayTemplateForCharge, this.vm.travelTimeOneWayManualForPay, val, this.vm.travelTimeOneWayTemplateForPay, this.vm.travelTimeOneWayTemplateForCharge);
  }

  @Watch('vm.journeyCalculationTypeForPay')
  async onJourneyCalculationTypeForPayChanged(val: JourneyCalculationType, oldVal: JourneyCalculationType) {
    await this.calculateTravel();
    //await this.calculateTravel(val, this.vm.journeyCalculationTypeForCharge, this.vm.journeyType, this.vm.distanceOneWayManualForPay, this.vm.distanceOneWayManualForCharge, this.vm.distanceOneWayTemplateForPay, this.vm.distanceOneWayTemplateForCharge, this.vm.travelTimeOneWayManualForPay, this.vm.travelTimeOneWayManualForCharge, this.vm.travelTimeOneWayTemplateForPay, this.vm.travelTimeOneWayTemplateForCharge);
  }

  @Watch('vm.journeyCalculationTypeForCharge')
  async onJourneyCalculationTypeForChargeChanged(val: JourneyCalculationType, oldVal: JourneyCalculationType) {
    await this.calculateTravel();
    //await this.calculateTravel(this.vm.journeyCalculationTypeForPay, val, this.vm.journeyType, this.vm.distanceOneWayManualForPay, this.vm.distanceOneWayManualForCharge, this.vm.distanceOneWayTemplateForPay, this.vm.distanceOneWayTemplateForCharge, this.vm.travelTimeOneWayManualForPay, this.vm.travelTimeOneWayManualForCharge, this.vm.travelTimeOneWayTemplateForPay, this.vm.travelTimeOneWayTemplateForCharge);
  }

  async calculateTravelOld(journeyCalculationTypeForPay: JourneyCalculationType, journeyCalculationTypeForCharge: JourneyCalculationType, journeyType: JourneyType, distanceOneWayManualForPay: number, distanceOneWayManualForCharge: number, distanceOneWayTemplateForPay: number, distanceOneWayTemplateForCharge: number, travelTimeOneWayManualForPay: number, travelTimeOneWayManualForCharge: number, travelTimeOneWayTemplateForPay: number, travelTimeOneWayTemplateForCharge: number) {
    
    let travelTimeOneWayForPay = travelTimeOneWayManualForPay;
    let distanceOneWayForPay = distanceOneWayManualForPay;
    if (journeyCalculationTypeForPay === JourneyCalculationType.Template) {
      travelTimeOneWayForPay = travelTimeOneWayTemplateForPay
      distanceOneWayForPay = distanceOneWayTemplateForPay;
    }

    let travelTimeOneWayForCharge = travelTimeOneWayManualForCharge;
    let distanceOneWayForCharge = distanceOneWayManualForCharge;
    if (journeyCalculationTypeForCharge === JourneyCalculationType.Template) {
      travelTimeOneWayForCharge = travelTimeOneWayTemplateForCharge
      distanceOneWayForCharge = distanceOneWayTemplateForCharge;
    } 

    if (journeyType === JourneyType.PassengerToLocation ||
      journeyType === JourneyType.PassengerFromLocation ||
      journeyType === JourneyType.DriverToLocation ||
      journeyType === JourneyType.DriverFromLocation) {

      this.vm.totalTravelTimeForPay = travelTimeOneWayForPay;
      this.vm.totalTravelTimeForCharge = travelTimeOneWayForCharge;
      this.vm.totalDistanceForPay = distanceOneWayForPay;
      this.vm.totalDistanceForCharge = distanceOneWayForCharge;
    } else {
      //Must be round trip or own way there
      this.vm.totalTravelTimeForPay = 2 * travelTimeOneWayForPay
      this.vm.totalTravelTimeForCharge = 2 * travelTimeOneWayForCharge
      this.vm.totalDistanceForPay = 2 * distanceOneWayForPay
      this.vm.totalDistanceForCharge = 2 * distanceOneWayForCharge
    }
  
    //Calculate the passenger amounts
    if (this.vm.journeyType === JourneyType.PassengerToLocation ||
    this.vm.journeyType === JourneyType.PassengerFromLocation ||
    this.vm.journeyType === JourneyType.PassengerRoundTrip) {
      if (this.vm.journeyType === JourneyType.PassengerRoundTrip) {
        this.vm.passengerDeduction = BookingDetailsModule.editTimesheetOptions.passengerDeductionRoundTrip
      } else {
        this.vm.passengerDeduction = BookingDetailsModule.editTimesheetOptions.passengerDeductionOneWay
      }
    }
    //Calculate the driver amounts
    if (this.vm.journeyType === JourneyType.OwnWayThere ||
      this.vm.journeyType === JourneyType.DriverToLocation ||
      this.vm.journeyType === JourneyType.DriverFromLocation ||
      this.vm.journeyType === JourneyType.DriverRoundTrip) {
    this.vm.driverExpensePay = BookingDetailsModule.editTimesheetOptions.driverUnitExpensePayRate * this.vm.totalDistanceForPay;
    this.vm.driverExpenseCharge = BookingDetailsModule.editTimesheetOptions.driverUnitExpenseChargeRate * this.vm.totalDistanceForCharge;
    }
    //Calculate travel time pay/charge
    this.vm.travelTimePay = this.vm.payRate * (this.vm.totalTravelTimeForPay /60)
    this.vm.travelTimeCharge = this.vm.chargeRate * (this.vm.totalTravelTimeForCharge /60)
  }

  async calculateTravel() {
    
    let travelTimeOneWayForPay = this.vm.travelTimeOneWayManualForPay;
    let distanceOneWayForPay = this.vm.distanceOneWayManualForPay;
    if (this.vm.journeyCalculationTypeForPay === JourneyCalculationType.Template) {
      travelTimeOneWayForPay = this.vm.travelTimeOneWayTemplateForPay
      distanceOneWayForPay = this.vm.distanceOneWayTemplateForPay;
    }

    let travelTimeOneWayForCharge = this.vm.travelTimeOneWayManualForCharge;
    let distanceOneWayForCharge = this.vm.distanceOneWayManualForCharge;
    if (this.vm.journeyCalculationTypeForCharge === JourneyCalculationType.Template) {
      travelTimeOneWayForCharge = this.vm.travelTimeOneWayTemplateForCharge
      distanceOneWayForCharge = this.vm.distanceOneWayTemplateForCharge;
    } 

    if (this.vm.journeyType === JourneyType.PassengerToLocation ||
      this.vm.journeyType === JourneyType.PassengerFromLocation ||
      this.vm.journeyType === JourneyType.DriverToLocation ||
      this.vm.journeyType === JourneyType.DriverFromLocation) {

      this.vm.totalTravelTimeForPay = travelTimeOneWayForPay;
      this.vm.totalTravelTimeForCharge = travelTimeOneWayForCharge;
      this.vm.totalDistanceForPay = distanceOneWayForPay;
      this.vm.totalDistanceForCharge = distanceOneWayForCharge;
    } else {
      //Must be round trip or own way there
      this.vm.totalTravelTimeForPay = 2 * travelTimeOneWayForPay
      this.vm.totalTravelTimeForCharge = 2 * travelTimeOneWayForCharge
      this.vm.totalDistanceForPay = 2 * distanceOneWayForPay
      this.vm.totalDistanceForCharge = 2 * distanceOneWayForCharge
    }
  
    //Calculate the passenger amounts
    if (this.vm.journeyType === JourneyType.PassengerToLocation ||
    this.vm.journeyType === JourneyType.PassengerFromLocation ||
    this.vm.journeyType === JourneyType.PassengerRoundTrip) {
      if (this.vm.journeyType === JourneyType.PassengerRoundTrip) {
        this.vm.passengerDeduction = BookingDetailsModule.editTimesheetOptions.passengerDeductionRoundTrip
      } else {
        this.vm.passengerDeduction = BookingDetailsModule.editTimesheetOptions.passengerDeductionOneWay
      }
    }
    //Calculate the driver amounts
    if (this.vm.journeyType === JourneyType.OwnWayThere ||
      this.vm.journeyType === JourneyType.DriverToLocation ||
      this.vm.journeyType === JourneyType.DriverFromLocation ||
      this.vm.journeyType === JourneyType.DriverRoundTrip) {
    this.vm.driverExpensePay = BookingDetailsModule.editTimesheetOptions.driverUnitExpensePayRate * this.vm.totalDistanceForPay;
    this.vm.driverExpenseCharge = BookingDetailsModule.editTimesheetOptions.driverUnitExpenseChargeRate * this.vm.totalDistanceForCharge;
    }
    //Calculate travel time pay/charge
    this.vm.travelTimePay = this.vm.payRate * (this.vm.totalTravelTimeForPay /60)
    this.vm.travelTimeCharge = this.vm.chargeRate * (this.vm.totalTravelTimeForCharge /60)
  }

  async calculateShift() {
    
    const startAtRounded = DateTimeUtils.toRoundedDate(1, new Date(`${this.vm.startAtDate}T${this.vm.startAtTime}`));
    const endAtRounded = DateTimeUtils.toRoundedDate(1, new Date(`${this.vm.startAtDate}T${this.vm.endAtTime}`));
    if (endAtRounded < startAtRounded) {
      endAtRounded.setDate(endAtRounded.getDate() + 1);
    }
    let duration: number = endAtRounded.getTime() - startAtRounded.getTime();
    let hours = duration/ (1000*3600);
    hours = Math.ceil(hours * Math.pow(10, 2)) / Math.pow(10, 2);
    this.vm.shiftUnitsGross = hours;

    if (!this.vm.isPaidBreak) {
      //Subtract the break minutes before calculating net
      duration = duration - (this.vm.break * 1000 * 60);
    }
    hours = duration/ (1000*3600);
    hours = Math.ceil(hours * Math.pow(10, 2)) / Math.pow(10, 2);
    this.vm.shiftUnitsNet = hours;
    this.vm.shiftPay = this.vm.shiftUnitsNet * this.vm.payRate;
    this.vm.shiftCharge = this.vm.shiftUnitsNet * this.vm.chargeRate;
  }

  get isPassenger() {
    if (this.vm.journeyType === JourneyType.PassengerToLocation ||
    this.vm.journeyType === JourneyType.PassengerFromLocation ||
    this.vm.journeyType === JourneyType.PassengerRoundTrip) {
      return true;
    }
    return false;
  }

  get isDriver() {
    if ( this.vm.journeyType === JourneyType.OwnWayThere ||
    this.vm.journeyType === JourneyType.DriverToLocation ||
    this.vm.journeyType === JourneyType.DriverFromLocation ||
    this.vm.journeyType === JourneyType.DriverRoundTrip) {
      return true;
    }
    return false;
  }


  
  @Watch('dialog')
  async onDialogChanged(val: boolean, oldVal: boolean) {
    if (val) {
      //We need to fetch the latest copy - passing this in as a prop means updated it becomes stale on second edit
      await BookingDetailsModule.getEditTimesheetOptions();
      const timesheet = BookingDetailsModule.bookedWorkersVM.timesheets.find((findTimesheet: TimesheetDto) => findTimesheet.id === this.timesheetId);
      //get the minimum pay rate
      const minimumPayRateRequest = new WorkerMinimumPayRateRequest();
      minimumPayRateRequest.date = new Date(timesheet.startAt).toISOString().substr(0,10);
      minimumPayRateRequest.workerId = timesheet.workerId;
      await BookingDetailsModule.getEditTimesheetMinimumPayRate(minimumPayRateRequest);
      
      //We need to fetch the latest copy - passing this in as a prop means updated at becomes stale on send edit
      //const timesheet = TimesheetListModule.timesheets.find((findTimesheet: TimesheetDto) => findTimesheet.id === this.timesheetId);
      this.vm = new TimesheetViewModel();
      this.vm.id = timesheet.id;
      this.vm.updatedAt = timesheet.updatedAt
      this.vm.payRate = timesheet.payRate;
      this.vm.chargeRate = timesheet.chargeRate;
      this.vm.startAtTime = DateTimeUtils.toHHMM(new Date(timesheet.startAt));
      this.vm.startAtDate = DateTimeUtils.toYYMMDD(new Date(timesheet.startAt));
      this.vm.endAtTime = DateTimeUtils.toHHMM(new Date(timesheet.endAt));
      this.vm.break = timesheet.break;
      this.vm.isPaidBreak = timesheet.isPaidBreak;
      this.vm.shift = BookingDetailsModule.bookedWorkersVM.selectedShift;
      this.vm.isJourneyTrackingEnabled = timesheet.isJourneyTrackingEnabled;
      this.vm.journeyType = timesheet.journeyType;
      this.vm.isSplitPayAndCharge = timesheet.isSplitPayAndCharge;
      this.vm.journeyCalculationTypeForPay = timesheet.journeyCalculationTypeForPay;
      this.vm.journeyCalculationTypeForCharge = timesheet.journeyCalculationTypeForCharge;
      this.vm.journeyTemplateForPay = timesheet.journeyTemplateForPay;
      this.vm.journeyTemplateForPayId = timesheet.journeyTemplateForPayId;
      this.vm.journeyTemplateForCharge = timesheet.journeyTemplateForCharge;
      this.vm.journeyTemplateForChargeId = timesheet.journeyTemplateForChargeId;
      if (this.vm.journeyCalculationTypeForPay === JourneyCalculationType.Manual) {
        this.vm.distanceOneWayManualForPay = timesheet.distanceOneWayForPay;
        this.vm.travelTimeOneWayManualForPay = timesheet.travelTimeOneWayForPay;
      } else {
        this.vm.distanceOneWayTemplateForPay = timesheet.journeyTemplateForPay.distanceOneWay;
        this.vm.travelTimeOneWayTemplateForPay = timesheet.journeyTemplateForPay.travelTimeOneWay;
      }

      if (this.vm.journeyCalculationTypeForCharge === JourneyCalculationType.Manual) {
        this.vm.distanceOneWayManualForCharge = timesheet.distanceOneWayForCharge;
        this.vm.travelTimeOneWayManualForCharge = timesheet.travelTimeOneWayForCharge;
      } else {
        this.vm.distanceOneWayTemplateForCharge = timesheet.journeyTemplateForCharge.distanceOneWay;
        this.vm.travelTimeOneWayTemplateForCharge = timesheet.journeyTemplateForCharge.travelTimeOneWay;
      }
      this.vm.totalDistanceForPay = timesheet.totalDistanceForPay;
      this.vm.totalDistanceForCharge = timesheet.totalDistanceForCharge;
      this.vm.totalTravelTimeForPay = timesheet.totalTravelTimeForPay;
      this.vm.totalTravelTimeForCharge = timesheet.totalTravelTimeForCharge;
      this.vm.passengerDeduction = timesheet.passengerDeduction;
      this.vm.driverUnitExpensePayRate = this.editTimesheetOptions.driverUnitExpensePayRate;
      this.vm.driverUnitExpenseChargeRate = this.editTimesheetOptions.driverUnitExpenseChargeRate;
      this.vm.isDriverExpensePayable = timesheet.isDriverExpensePayable;
      this.vm.isDriverExpenseChargeable = timesheet.isDriverExpenseChargeable;
      this.vm.driverExpensePay = timesheet.driverExpensePay;
      this.vm.driverExpenseCharge = timesheet.driverExpenseCharge;
      this.vm.isTravelTimePayable = timesheet.isTravelTimePayable;
      this.vm.isTravelTimeChargeable = timesheet.isTravelTimeChargeable;
      this.vm.travelTimePay = timesheet.travelTimePay
      this.vm.travelTimeCharge = timesheet.travelTimeCharge;
      this.vm.minimumPayRate = BookingDetailsModule.editTimesheetMinimumPayRate;
    } else {
      //Reset
      this.vm = new TimesheetViewModel();
    }
  }

  get isLessThanMinimumPayRate() {
    if (this.vm.minimumPayRate <= 0) {
      //Couldn't get the minimum pay rate for this worker
      return false;
    }
    return this.vm.payRate < this.vm.minimumPayRate;
  }

  get editTimesheetOptions() {
    return BookingDetailsModule.editTimesheetOptions;
  }

  async save() {
    if (!(this.$refs.form as any).validate()) {
      return;
    }
    await BookingDetailsModule.editTimesheet(this.vm);
    this.dialog = false;
  }

  get journeyTypes() {
    return ListUtils.journeyTypeOptions();
  }

  get journeyCalculationTypes() {
    return ListUtils.journeyCalculationTypeOptions();
  }

  get travelTimes() {
    return ListUtils.travelTimes();
  }

  get breaks() {
    return ListUtils.breaks();
  }
}
